// extracted by mini-css-extract-plugin
module.exports = {"main":"Tabs__main___1CTq7","innerWrapper":"Tabs__innerWrapper___2Wp0P","tab":"Tabs__tab___3vTfe","active":"Tabs__active___-0UXW"};